/**
 * FBG Product Gallery — Slick Slider Initialisation
 * Depends on: jQuery 3.x + Slick (both loaded globally in theme.liquid)
 * All selectors scoped to .fbg-gallery to avoid collisions.
 */
(function ($) {
  'use strict';

  var FBG_BREAKPOINT = 989; // matches CSS mobile+tablet breakpoint

  function initGallery($gallery) {
    var sectionId = $gallery.data('section-id');
    var $main     = $gallery.find('.fbg-gallery-main');
    var $thumbs   = $gallery.find('.fbg-gallery-thumbs');
    var $counter  = $gallery.find('.fbg-gallery-counter');
    var $counterCurrent = $counter.find('.fbg-counter-current');
    var $mobileThumbsWrap = $gallery.find('.fbg-gallery-mobile-thumbs');
    var $mobileThumbs = $mobileThumbsWrap.find('.fbg-gallery-mobile-thumb');
    var mediaCount = parseInt($gallery.data('media-count'), 10) || 1;

    // ---- MAIN SLIDER ----
    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: false,
      draggable: false,
      swipe: false,
      adaptiveHeight: false,
      useCSS: true,
      useTransform: true,
      speed: 300,
      cssEase: 'cubic-bezier(0.23, 1, 0.32, 1)',
      waitForAnimate: false,
      responsive: [
        {
          breakpoint: FBG_BREAKPOINT + 1,
          settings: {
            fade: false,
            adaptiveHeight: false,
            draggable: true,
            swipe: true,
            dots: false,
            useCSS: true,
            useTransform: true,
            speed: 350,
            cssEase: 'cubic-bezier(0.23, 1, 0.32, 1)',
            touchThreshold: 5,
            touchMove: true,
            waitForAnimate: false,
            swipeToSlide: true,
            edgeFriction: 0.15
          }
        }
      ]
    });

    // ---- THUMBNAIL SLIDER (retired) ----
    // The vertical thumbnail column is hidden at every breakpoint since the
    // overlay strip took over navigation. It is deliberately NOT initialised
    // as a slick slider any more: keeping it as the main slider's asNavFor
    // (slidesToShow: 5, infinite: false) made slick clamp navigation on
    // products with fewer media, so the LAST slide could never be selected
    // from the overlay thumbs.

    // ---- DESKTOP THUMBNAIL VERTICAL ARROWS ----
    var $thumbUp   = $gallery.find('.fbg-thumb-arrow--up');
    var $thumbDown = $gallery.find('.fbg-thumb-arrow--down');

    function updateThumbArrows() {
      if (!$thumbs.length || !$thumbs.hasClass('slick-initialized')) return;
      var slickObj = $thumbs.slick('getSlick');
      var current  = slickObj.currentSlide;
      var total    = slickObj.slideCount;
      var show     = slickObj.options.slidesToShow;

      if (total <= show) {
        $thumbUp.removeClass('fbg-thumb-arrow--visible');
        $thumbDown.removeClass('fbg-thumb-arrow--visible');
        return;
      }

      $thumbUp.toggleClass('fbg-thumb-arrow--visible', current > 0);
      $thumbDown.toggleClass('fbg-thumb-arrow--visible', current < total - show);
    }

    $thumbUp.on('click', function () {
      if ($thumbs.hasClass('slick-initialized')) $thumbs.slick('slickPrev');
    });
    $thumbDown.on('click', function () {
      if ($thumbs.hasClass('slick-initialized')) $thumbs.slick('slickNext');
    });

    $thumbs.on('afterChange', function () {
      updateThumbArrows();
    });

    // Initial check after a tick (Slick needs to be ready)
    setTimeout(updateThumbArrows, 100);

    // ---- MOBILE ARROWS ----
    var $prevArrow = $gallery.find('.fbg-gallery-arrow--prev');
    var $nextArrow = $gallery.find('.fbg-gallery-arrow--next');

    $prevArrow.on('click', function () {
      $main.slick('slickPrev');
    });
    $nextArrow.on('click', function () {
      $main.slick('slickNext');
    });

    function updateArrowStates(currentSlide) {
      var slideCount = $main.slick('getSlick').slideCount;
      $prevArrow.prop('disabled', currentSlide === 0);
      $nextArrow.prop('disabled', currentSlide >= slideCount - 1);
    }
    // Set initial state
    updateArrowStates(0);

    // ---- Scroll mobile thumb strip to keep active thumb visible ----
    function scrollToActiveThumb(index) {
      var $activeThumb = $mobileThumbs.filter('[data-slide-index="' + index + '"]');
      if ($activeThumb.length && $mobileThumbsWrap.length) {
        $activeThumb[0].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }

    // ---- Check if slide has video and toggle class on gallery ----
    function updateVideoSlideState(currentSlide) {
      var $currentSlide = $main.find('.slick-slide[data-slick-index="' + currentSlide + '"]');
      var isVideo = $currentSlide.find('.fbg-video-media, .fbg-video-inline').length > 0;
      $gallery.toggleClass('fbg-gallery--video-active', isVideo);
    }

    // ---- MUTE/UNMUTE TOGGLE STATE ----
    var userWantsSound = false; // persists across slides within this gallery session

    // ---- INLINE VIDEO AUTOPLAY: play/pause native videos on slide change ----
    function handleInlineVideos(currentSlide) {
      // Pause all inline videos and remove playing state
      $main.find('.fbg-video-inline').each(function () {
        var $wrap = $(this);
        var video = $wrap.find('video')[0];
        if (video) {
          video.pause();
          video.currentTime = 0;
          video.muted = true; // always re-mute when leaving slide
        }
        $wrap.removeClass('fbg-video-playing');
      });

      // Auto-play the video in the current slide
      var $currentSlide = $main.find('.slick-slide[data-slick-index="' + currentSlide + '"]');
      var $inlineVideo = $currentSlide.find('.fbg-video-inline');
      if ($inlineVideo.length) {
        var video = $inlineVideo.find('video')[0];
        if (video) {
          video.muted = true; // must be muted for autoplay policy
          var playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.then(function () {
              $inlineVideo.addClass('fbg-video-playing');
              // If user previously enabled sound, unmute after autoplay starts
              if (userWantsSound) {
                video.muted = false;
                $inlineVideo.find('.fbg-video-mute-toggle')
                  .addClass('fbg-mute-toggle--unmuted')
                  .attr('aria-label', 'Mute video');
              } else {
                $inlineVideo.find('.fbg-video-mute-toggle')
                  .removeClass('fbg-mute-toggle--unmuted')
                  .attr('aria-label', 'Unmute video');
              }
            }).catch(function () {
              // Autoplay blocked — keep poster visible
            });
          }
        }
      }
    }

    // ---- MUTE/UNMUTE BUTTON CLICK HANDLER ----
    $main.on('click', '.fbg-video-mute-toggle', function (e) {
      e.stopPropagation(); // prevent zoom or other slide interactions
      var $btn = $(this);
      var $wrap = $btn.closest('.fbg-video-inline');
      var video = $wrap.find('video')[0];
      if (!video) return;

      if (video.muted) {
        video.muted = false;
        userWantsSound = true;
        $btn.addClass('fbg-mute-toggle--unmuted').attr('aria-label', 'Mute video');
      } else {
        video.muted = true;
        userWantsSound = false;
        $btn.removeClass('fbg-mute-toggle--unmuted').attr('aria-label', 'Unmute video');
      }
    });

    // ---- AFTER-CHANGE: Update counter + mobile thumb active state + arrows ----
    $main.on('afterChange', function (_e, _slick, currentSlide) {
      // Counter
      $counterCurrent.text(currentSlide + 1);

      // Arrow disabled states
      updateArrowStates(currentSlide);

      // Video slide detection
      updateVideoSlideState(currentSlide);

      // Pause all deferred media when sliding away
      if (window.pauseAllMedia) window.pauseAllMedia();

      // Auto-play/pause inline videos
      handleInlineVideos(currentSlide);

      // Mobile thumb active + auto-scroll
      $mobileThumbs.removeClass('fbg-mobile-thumb--active');
      $mobileThumbs.filter('[data-slide-index="' + currentSlide + '"]')
        .addClass('fbg-mobile-thumb--active');
      scrollToActiveThumb(currentSlide);
    });

    // ---- Ensure inline videos have required attributes for autoplay ----
    $main.find('.fbg-video-inline video').each(function () {
      this.setAttribute('playsinline', '');
      this.setAttribute('webkit-playsinline', '');
      this.muted = true;
      this.removeAttribute('controls');
    });

    // Initial video state check + autoplay if first slide is video
    updateVideoSlideState(0);
    handleInlineVideos(0);

    // ---- MOBILE THUMB TAP → Go to slide ----
    $mobileThumbs.on('click', function () {
      var idx = parseInt($(this).data('slide-index'), 10);
      $main.slick('slickGoTo', idx);
    });

    // ---- HOVER ZOOM (Desktop only, if enabled) ----
    if ($gallery.data('enable-zoom') !== false && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
      $main.on('click', '.fbg-gallery-slide', function (e) {
        var $slide = $(this);
        // Skip zoom on video/3D slides
        if ($slide.find('.fbg-video-media, .fbg-video-inline').length) return;
        if ($slide.hasClass('fbg-zoom-active')) {
          $slide.removeClass('fbg-zoom-active');
        } else {
          if ($slide.find('> img').length) {
            $slide.addClass('fbg-zoom-active');
            applyZoomPosition(e, $slide);
          }
        }
      });

      $main.on('mousemove', '.fbg-gallery-slide.fbg-zoom-active', function (e) {
        applyZoomPosition(e, $(this));
      });

      $main.on('mouseleave', '.fbg-gallery-slide.fbg-zoom-active', function () {
        $(this).removeClass('fbg-zoom-active');
      });
    }

    function applyZoomPosition(e, $slide) {
      var offset = $slide.offset();
      var x = ((e.pageX - offset.left) / $slide.width()) * 100;
      var y = ((e.pageY - offset.top) / $slide.height()) * 100;
      $slide[0].style.setProperty('--fbg-zoom-x', x + '%');
      $slide[0].style.setProperty('--fbg-zoom-y', y + '%');
    }

    // ---- EXPAND BUTTON → Open FBG Lightbox ----
    var $lightbox = $('#FbgLightbox-' + sectionId);
    var $lbSlides = $lightbox.find('.fbg-lightbox__slide');
    var $lbPrev   = $lightbox.find('.fbg-lightbox__arrow--prev');
    var $lbNext   = $lightbox.find('.fbg-lightbox__arrow--next');
    var $lbClose  = $lightbox.find('.fbg-lightbox__close');
    var $lbBackdrop = $lightbox.find('.fbg-lightbox__backdrop');
    var $lbCounter  = $lightbox.find('.fbg-lightbox__counter-current');
    var lbCurrent = 0;
    var lbTotal   = $lbSlides.length;

    function lbShow(index) {
      lbCurrent = Math.max(0, Math.min(index, lbTotal - 1));
      $lbSlides.removeClass('fbg-lightbox__slide--active');
      $lbSlides.eq(lbCurrent).addClass('fbg-lightbox__slide--active');
      $lbCounter.text(lbCurrent + 1);
      $lbPrev.toggle(lbCurrent > 0);
      $lbNext.toggle(lbCurrent < lbTotal - 1);
    }

    function lbOpen(startIndex) {
      lbShow(startIndex || 0);
      $lightbox.addClass('fbg-lightbox--open');
      $lightbox.attr('aria-hidden', 'false');
      $('body').css('overflow', 'hidden');
    }

    function lbCloseHandler() {
      $lightbox.removeClass('fbg-lightbox--open');
      $lightbox.attr('aria-hidden', 'true');
      $('body').css('overflow', '');
    }

    $gallery.find('.fbg-gallery-expand').on('click', function () {
      var currentSlide = $main.slick('slickCurrentSlide');
      lbOpen(currentSlide);
    });

    $lbPrev.on('click', function () { lbShow(lbCurrent - 1); });
    $lbNext.on('click', function () { lbShow(lbCurrent + 1); });
    $lbClose.on('click', lbCloseHandler);
    $lbBackdrop.on('click', lbCloseHandler);

    // ESC key closes lightbox
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $lightbox.hasClass('fbg-lightbox--open')) {
        lbCloseHandler();
      }
      if ($lightbox.hasClass('fbg-lightbox--open')) {
        if (e.key === 'ArrowLeft') lbShow(lbCurrent - 1);
        if (e.key === 'ArrowRight') lbShow(lbCurrent + 1);
      }
    });
  }

  // ---- WAIT FOR SLICK THEN INIT ----
  function waitForSlickAndInit(callback, maxAttempts) {
    var attempts = 0;
    maxAttempts = maxAttempts || 50; // 50 x 100ms = 5 seconds max

    function check() {
      attempts++;
      if ($.fn.slick) {
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(check, 100);
      } else {
        console.warn('FBG Gallery: slick not available after ' + (maxAttempts * 100) + 'ms');
      }
    }

    check();
  }

  // ---- INIT ON DOM READY ----
  $(function () {
    waitForSlickAndInit(function () {
      $('.fbg-gallery').each(function () {
        initGallery($(this));
      });
    });
  });

  // ---- RE-INIT ON SECTION RE-RENDER (Theme Editor) ----
  if (Shopify && Shopify.designMode) {
    $(document).on('shopify:section:load', function (e) {
      var $target = $(e.target);
      var $gallery = $target.find('.fbg-gallery');
      if ($gallery.length) {
        waitForSlickAndInit(function () {
          initGallery($gallery);
        });
      }
    });
  }
})(jQuery);
